import {KPI_HEADING_ITEM_LIST} from './../actions/ActionTypes';
import InitialState from './InitialState';

const KPIHeadingItemListReducer = (state = InitialState.allKPIData, action) => {
    switch (action.type) {
        case KPI_HEADING_ITEM_LIST: {
            return action.headingItemList;
        }

        default:
            return state;
    }
};
export default KPIHeadingItemListReducer;



// WEBPACK FOOTER //
// ./src/reducers/KPIHeadingItemListReducer.js